import type { UppFloorPlanElement } from './floor-plan-element';

/**
 * Logical room (dimensions in cm) backing the Konva floor plan presentation.
 */
export interface UppKonvaRoom {
  widthCm: number;
  heightCm: number;
  name?: string;
}

export class UppFloorPlanModel {
  constructor(
    readonly room: UppKonvaRoom,
    readonly elements: readonly UppFloorPlanElement[],
  ) {}
}
